export { default as IntlService } from './services/intl-service';
export { default as TemplateService } from './services/template-service';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-ooxml/dist/es/services.js
// module id = ../../../../@progress/kendo-ooxml/dist/es/services.js
// module chunks = vendor